import { render, staticRenderFns } from "./SwitchEnterpriseDialog.vue?vue&type=template&id=156a1730&scoped=true"
import script from "./SwitchEnterpriseDialog.vue?vue&type=script&lang=js"
export * from "./SwitchEnterpriseDialog.vue?vue&type=script&lang=js"
import style0 from "./SwitchEnterpriseDialog.vue?vue&type=style&index=0&id=156a1730&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156a1730",
  null
  
)

export default component.exports